import styled from 'styled-components';
import { spacing } from '_utils/props';
import color from '_utils/styles/color';

export const EditorWrapper = styled.div`
  ${({ theme }) => spacing({ theme, $py: 2 })}
  /* invis border helps editor size calc */
  border: 1px solid transparent;
`;

export const Rule = styled.div`
  margin: 0;
  ${({ theme }) => spacing({ theme, $my: 7 })}
  height: 1px;
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.all.deepBlueTint15};
  ${EditorWrapper} & {
    margin: 0;
  }
`;
